import { PhotoPrintsPdpStore } from '@ff-scene-plugins/photo-prints-redux/store';
import { firePricingEventOnChange } from './pricing';

export const subscribe = (store: PhotoPrintsPdpStore) => {
    firePricingEventOnChange(store);
};